import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StarHaven from "@/pages/StarHaven";
import StarHavenAdmin from "@/pages/StarHavenAdmin";
import Laboratory from "@/pages/Laboratory";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StarHaven />} />
          <Route path="/starhaven-admin" element={<StarHavenAdmin />} />
          <Route path="/lab" element={<Laboratory />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
